import { module } from 'angular';

import { STATE_CONFIG_PROVIDER, StateConfigProvider } from '@spinnaker/core';

import { rootRoutes } from 'layout/Routes';

export const ARMORY_PLATFORM_STATES = 'armory.platform.states';
module(ARMORY_PLATFORM_STATES, [
  STATE_CONFIG_PROVIDER,
]).config((stateConfigProvider: StateConfigProvider) => {
  'ngInject';
  rootRoutes.forEach(route => {
    stateConfigProvider.addToRootState(route);
  });
});
